import React from 'react';
import { useCart } from '../context/CartContext';
export function Men() {
  const {
    addToCart
  } = useCart();
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-725">
      <div className="max-w-[1800px] mx-auto" data-id="element-726">
        <header className="mb-20 text-center" data-id="element-727">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.3em] md:tracking-[0.5em] mb-4 block text-black/40" data-id="element-728">
            Masculine Authority
          </span>
          <h1 className="text-2xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-729">
            Men
          </h1>
          <p className="max-w-xl mx-auto text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase px-4 md:px-0" data-id="element-730">
            Tailored Agbadas and modern sets for the contemporary gentleman.
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-731">
          {['https://cdn.magicpatterns.com/uploads/24GiQwrwzepMESJJTXz3Q3/image.png', 'https://cdn.magicpatterns.com/uploads/bxTL7vVABPe8YuDE1LiVeu/image.png'].map((img, i) => <div key={i} className="group" data-id="element-732">
              <div className="aspect-[4/5] bg-grey-divider overflow-hidden mb-6 relative" data-id="element-733">
                <img src={img} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" alt="Menswear" data-id="element-734" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center opacity-0 group-hover:opacity-100" data-id="element-735">
                  <button onClick={() => addToCart({
                id: `men-${i}`,
                name: `Menswear Look ${i + 1}`,
                price: '$450.00',
                image: img,
                quantity: 1,
                size: 'OS'
              })} className="bg-white text-black px-6 py-3 text-xs font-display font-bold uppercase tracking-widest hover:bg-black hover:text-white transition-colors" data-id="element-736">
                    Add to Bag
                  </button>
                </div>
              </div>
              <div className="flex justify-between items-start" data-id="element-737">
                <div data-id="element-738">
                  <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase mb-1" data-id="element-739">
                    Menswear Look {i + 1}
                  </h3>
                  <p className="text-sm font-light text-black/50" data-id="element-740">$450.00</p>
                </div>
                <button onClick={() => addToCart({
              id: `men-${i}`,
              name: `Menswear Look ${i + 1}`,
              price: '$450.00',
              image: img,
              quantity: 1,
              size: 'OS'
            })} className="md:hidden text-xs font-display font-bold uppercase tracking-widest border-b border-black pb-0.5" data-id="element-741">
                  Add to Bag
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}